module.exports = __webpack_public_path__ + "static/media/MF.8c779e8d.png";